import { useEffect } from 'react';

import { env } from '@/config/env';

/** Sincroniza el título del documento con la pantalla activa. */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    const previous = document.title;

    if (title) {
      document.title = `${title} · ${env.appName}`;
    }

    return () => {
      document.title = previous;
    };
  }, [title]);
}
